<template>
  <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
    <header id="header" class="mdl-layout__header">
      <div class="mdl-layout__header-row">
        <span class="mdl-layout-title">Solicitações</span>
        <div class="mdl-layout-spacer"></div>
        <div class="mdl-textfield mdl-js-textfield mdl-textfield--expandable mdl-textfield--floating-label mdl-textfield--align-right">
        <label class="mdl-button mdl-js-button mdl-button--icon"
               for="fixed-header-drawer-exp">
          <i class="material-icons">search</i>
        </label>
        <div class="mdl-textfield__expandable-holder">
          <input class="mdl-textfield__input" type="text" v-model="search" id="fixed-header-drawer-exp" v-on:input="searchMessages">
        </div>
      </div>        
      </div>
    </header>
    <div class="mdl-layout__drawer">
      <span class="mdl-layout-title">Ignis Equipes</span>
      <nav class="mdl-navigation">
        <router-link class="mdl-navigation__link" to="/" @click.native="hideMenu"><i class="material-icons">calendar_today</i> Agenda</router-link>
        <router-link class="mdl-navigation__link" to="/inbox" @click.native="hideMenu" v-if="demo"><i class="material-icons">mail_outline</i> Comunicados</router-link>
        <router-link class="mdl-navigation__link" to="/outbox" @click.native="hideMenu" v-if="demo"><i class="material-icons">message</i> Solicitações</router-link>
        <router-link class="mdl-navigation__link" to="/surveys" @click.native="hideMenu" v-if="demo"><i class="material-icons">live_help</i> Questionários</router-link>
      </nav>
    </div>
    <main class="mdl-layout__content">
      <div class="page-content">
        <div v-for="message in messages" class="calendar-card" :key="message.id" v-on:click="openMessage(message)" v-bind:class="messageClass(message)">
          <i class="pull-right material-icons" v-html="messageIcon(message)"></i>
          <strong>{{ message.title }}</strong>
        </div>      
      </div>
    </main>
  </div>
</template>
<script>

  import 'material-design-lite'

  var current_id
  var current_visit
  export default {
    data: function() {
      return {
        demo: process.env.FSM_DEMO,
        search: '',
        messages: [
          {id: 1, title: 'Requisição de Férias de 01/12/2018 a 23/12/2018', body: 'Informamos que não haverá expediente no dia 02/11/2018', date: '2018-10-25'},
          {id: 2, title: 'Contra-cheque', date: '2018-10-25'},
          {id: 3, title: 'Aviso de falta', date: '2018-10-25'}
        ]
      }  
    },
    mounted() {
      componentHandler.upgradeAllRegistered();
    },    
    methods: {
      formatDate: function(date) {
        return moment(date).format('dddd, DD/MM/YYYY')
      },
      formatDay: function(date) {
        return moment(date).format('DD')
      },
      formatDayOfWeek: function(date) {
        return moment(date).format('ddd')
      },
      openMessage: function(message) {
        this.$router.push("/messages/" + message.id)
      },
      visitUrl: function(message) {
        return '/messages/' + message.id
      },
      messageClass: function(visit) {
        return 'open';
      },      
      messageIcon: function(visit) {
        if (visit.status == 'closed') {
          if (visit.received_date)
            return 'done_all'
          else
            return 'done'  
        }
        return null;
      },
      searchMessages: function() {
        
      }
    }
  }
</script>
<style>
  .pull-left {
    float: left;
  }
  .pull-right {
    float: right;
  }
  .center {
    text-align: center;
  }
  h5 {
    margin-top: 0px;
    margin-bottom: 0px;
  }
</style>


// WEBPACK FOOTER //
// src/components/OutboxView.vue